import CategoryHeader from '../CategoryHeader'
import PackageItem from '../PackageItem/PackageItem'

interface Props {
    packages: any[]
    selectedProducts: any[]
    onSelectionChange: any
    addProductToBasket: (addedProduct: any, isPack: boolean) => void
    removeProductFromBasket: (product: any) => void
}

function PopularPackages(props: Props) {
    const packages: any[] = props.packages

    return (
        <>
            <CategoryHeader title='Populaire pakketten' />
            <ul className='flex flex-col md:flex-row mt-4 divider-x-50 shadow-sm border-full bg-white rounded-xl w-full'>
                {packages?.map((a) => {
                    const inBasket = props.selectedProducts.find((curr) => curr._isPack === true && curr.id === a.id)

                    return (
                        <PackageItem
                            a={a}
                            layout='block'
                            key={`package-${a.id}`}
                            inBasket={inBasket}
                            addProductToBasket={props.addProductToBasket}
                            removeProductFromBasket={props.removeProductFromBasket}
                        />
                    )
                })}
            </ul>
        </>
    )
}

export default PopularPackages
